import { api } from '../../../../redux/setupAxios';

export const AUTH_OTP_URL = "auth/auth-otp";
export const INFO_SHOPIFY_URL = "shopify/shopify-info";
export const SHOPIFY_LOGIN_USER = "shopify/login-serverless";
export const LOGIN_URL = "auth/login";
export const REGISTER_MERCHANT_URL = "merchants/register-merchant";
export const SNS_URL = "merchants/send-sns-register";
export const REGISTER_URL = "auth/register";
export const REPLACE_PASSWORD_URL = "auth/replace-password";
export const REQUEST_PASSWORD_URL = "auth/send-otp-password";
export const SAVE_PARAMS_URL = "merchants/options";
export const SEND_OTP_URL = "auth/send-otp-request";
export const ONBOARDING_REGISTER = "auth/onboarding-register";

export const ME_URL = 'auth/me';
const ENV = localStorage.getItem('envSquadded');
const SQUAD_ORIGIN = ENV === 'STAGING' || ENV === 'DEV' ? 'squad-shopping.com' : 'squadded.co';

export function login(email, password) {
	return api.post(LOGIN_URL, { email, password });
}

export function register(email, fullname, password, merchantId, profile, approved) {
	return api.post(REGISTER_URL, { email, fullname, merchantId, password, profile, approved })
		.then(({ data }) => data)
		.catch(() => null);
}

export async function registerMerchant({ url, label, merchantId, options }) {
	try {
		return await api.post(REGISTER_MERCHANT_URL, { url, label, merchantId, options });
	} catch (error) { return; }
}
export async function sendSnsRegister(params) {
	try {
		return await api.post(SNS_URL, params);
	} catch (error) { return; }
}

export function onboardingRegister(params) {
	return api.post(ONBOARDING_REGISTER, params);
}

export function sendMerchantParams(params, shopifyInfo) {
	return api.post(SAVE_PARAMS_URL, { ...params, shopifyInfo });
}

export function sendOtp(params) {
	return api.post(SEND_OTP_URL, params);
}
export async function authOtp({ otp, email, resetPasswordCode, merchantId }) {
	return api.post(AUTH_OTP_URL, { otp, email, resetPasswordCode, SQUAD_ORIGIN, merchantId });
}

export function forgotPasswordSendOtp(params) {
	return api.post(REQUEST_PASSWORD_URL, params);
}

export function replacePassword(params) {
	return api.post(REPLACE_PASSWORD_URL, params);
}

export function getUserByToken() {
	// Authorization head should be fulfilled in interceptor.
	return api
		.get(ME_URL)
		.then(({ data }) => data)
		.catch(() => null);
}

export async function verifyShopifyToken({ shopifyToken }) {
	return await api.post(SHOPIFY_LOGIN_USER, { token: shopifyToken })
		.then(({ data }) => data)
		.catch(() => null);
}
export async function getShopifyInfo({ shopifyToken }) {
	return await api.post(INFO_SHOPIFY_URL, { token: shopifyToken });
}
